
import React from 'react';
import { Card } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Link } from 'react-router-dom';

const LiveActivitySection = ({ liveData }: { liveData: { presences: any[] } }) => (
  <div className="space-y-6">
    <div>
      <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Live Activity</h2>
      <p className="text-gray-500 mt-1">Real-time user activity across the entire website.</p>
    </div>
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <Card className="p-6 lg:col-span-1">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">Live Users</p>
            <p className="text-3xl font-bold text-gray-900 mt-1">{liveData.presences.length}</p>
              <p className="text-xs text-gray-500 mt-1">across the website</p>
          </div>
          <div className={`p-3 rounded-xl bg-red-500 text-white`}>
            <Users className="w-6 h-6" />
          </div>
        </div>
      </Card>
      <Card className="p-6 lg:col-span-2">
        <h3 className="text-lg font-semibold mb-4">Live User Locations</h3>
        <div className="max-h-60 overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow className="sticky top-0 bg-white">
                <TableHead>Page / Game Title</TableHead>
                <TableHead>Path</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {liveData.presences.length > 0 ? (
                liveData.presences.map((p: any, i: number) => (
                  <TableRow key={i}>
                    <TableCell className="font-medium">{p.gameTitle || p.pageTitle || 'Unknown Page'}</TableCell>
                    <TableCell>
                      <Link to={p.path} className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">{p.path}</Link>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} className="text-center h-24">
                    No users currently active on the website.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      </Card>
    </div>
  </div>
);

export default LiveActivitySection;
